import floor from 'lodash/floor';

export const precision = (num, precision = 2) => floor(num, precision);

export const formatPlanName = ({ year, month, version = '*' }) => {
  return `Monthly Plan ${year}-${month.padStart(2, '0')}.${version}`;
};

export const getMetricTypeById = (id) => (id === 2 ? 'number' : 'percent');
